import React, { FC } from "react";
import Select from "react-select";
import { OptionModel } from "../../shared/models/option.model";

interface SelectProps {
  options: OptionModel[];
  selectedValue?: string | undefined | null;
  placeHolder?: string;
  onChange: (selectedValue: any) => void;
  optionsHeight?: string;
}

const TabularSelectComponent: FC<SelectProps> = ({
  options,
  selectedValue = null,
  placeHolder,
  onChange,
  optionsHeight = "400px",
}) => {
  const formattedOptions = options?.map((option: any) => ({
    value: option.DisplayLevel,
    label: option.DisplayLevel,
  }));

  const selectedOption = formattedOptions?.find(
    (option) => option.value === selectedValue
  );

  return (
    <Select
      options={formattedOptions}
      value={selectedOption}
      onChange={(option) => onChange(option?.value)}
      placeholder={placeHolder}
      classNamePrefix="custom-select"
      styles={{
        menu: (provided) => ({
          ...provided,
          maxHeight: optionsHeight,
          overflowY: "auto",
        }),
        menuList: (provided) => ({
          ...provided,
          maxHeight: optionsHeight,
          overflowY: "auto",
        }),
        control: (provided) => ({
          ...provided,
          fontSize: "16px",
          padding: "5px",
          height: "45px",
        }),
      }}
    />
  );
};

export default TabularSelectComponent;
